"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allEpics = void 0;
const ro = require("redux-observable");
const home_1 = require("./home");
const members_1 = require("./members");
const users_1 = require("./users");
const permissions_1 = require("./permissions");
const wizard_1 = require("./wizard");
const change_1 = require("./change");
const copy = require("./copy");
const deleteEpics = require("./delete");
const customerUserGroupsEpics = require("./customerUserGroups");
const lightAdminEpics = require("./lightAdmin");
const _folderTree = require("../../modules/files/tree/epics");
const _crud = require("../../modules/files/crud/epics");
const _dashboard = require("../../modules/dashboard/epics");
const _statusesOrType = require("../../modules/project/statusesOrTypes/epics");
const _userGroupList = require("../../modules/usergroup/list/epics");
const _userGroupInvite = require("../../modules/usergroup/invite/epics");
const permissionsFolderTree = _folderTree.default('permissions');
const crud = _crud.default('permissions');
const homeFolderTree = _folderTree.default('project/home');
const dashboard = _dashboard.default('project');
const statuses = _statusesOrType.default('project-statuses', 'statuses');
const types = _statusesOrType.default('project-types', 'types');
const userGroupListMembers = _userGroupList.default('project/members');
const userGroupListHome = _userGroupList.default('project/home');
const userGroupListWizard = _userGroupList.default('project/wizard');
const userGroupInviteMembers = _userGroupInvite.default('project/members');
const userGroupInviteHome = _userGroupInvite.default('project/home');
const userGroupInviteWizard = _userGroupInvite.default('project/wizard');
exports.allEpics = ro.combineEpics(permissions_1.updateTree, 
// home
home_1.fetchRoot, home_1.fetchProjectById, home_1.fetchProjectGroups, home_1.addFolderShortcut, home_1.uploadProjectCover, home_1.removeProjectCover, home_1.fetchFolderShortcuts, home_1.deleteFolderShortcut, 
// members
home_1.toggleShowParties, members_1.handleCreateCategory, members_1.handleDeleteGroup, members_1.handleUpdateCategory, members_1.handleCreateUserProfile, members_1.handleUpdateUserProfile, members_1.handleCreateWorksiteDiary, members_1.handleUpdateWorksiteDiary, members_1.handleCreateTRMVRMeter, members_1.handleUpdateTRMVRMeter, members_1.handleDeleteUsers, members_1.handleDeleteGroupsUsers, members_1.moveUsersToGroup, 
// users
users_1.getUserListExcel, users_1.fetchProjectUserList, 
// permissions
permissions_1.fetchProjectFolderPermissions, permissions_1.handleUpdatePermissions, permissions_1.savePermissions, 
// wizard
wizard_1.changeStep, wizard_1.fetchCustomers, wizard_1.fetchPrintProviders, wizard_1.createProject, wizard_1.searchBillingInformations, wizard_1.getProject, wizard_1.handleDeleteEditCategory, wizard_1.handleDeleteEditUserGroup, wizard_1.handleRemoveUserFromGroup, wizard_1.insertMeta, wizard_1.fetchMetas, wizard_1.deleteMeta, wizard_1.getSalesRepresentive, wizard_1.finishCreateProject, wizard_1.fetchProjectFeatures, copy.searchCompany, copy.listTemplates, copy.copyProject, deleteEpics.deleteProject, permissionsFolderTree.copyFiles, permissionsFolderTree.fetchTree, homeFolderTree.copyFiles, homeFolderTree.fetchTree, crud.update, crud.createFolder, crud.deleteFile, 
// dashboard
dashboard.create, dashboard.edit, dashboard.fetch, dashboard.remove, 
// Types And Statuses
statuses.fetch, statuses.add, statuses.edit, statuses.remove, types.fetch, types.add, types.edit, types.remove, 
// Usergroup list
userGroupListMembers.fetch, userGroupListHome.fetch, userGroupListWizard.fetch, 
// invite
userGroupInviteMembers.invite, userGroupInviteHome.invite, userGroupInviteWizard.invite, 
// Customer user groups
customerUserGroupsEpics.fetch, customerUserGroupsEpics.link, 
// Light admin
lightAdminEpics.create, lightAdminEpics.edit, 
//Change
change_1.changeProjectCustomer);
//# sourceMappingURL=index.js.map